import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import React from 'react';
import PropTypes from 'prop-types';
var TooltipErrorBoundry = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(TooltipErrorBoundry, _React$Component);
  function TooltipErrorBoundry(props) {
    return _React$Component.call(this, props) || this;
  }
  var _proto = TooltipErrorBoundry.prototype;
  _proto.componentDidCatch = function componentDidCatch(error, info) {
    console.error('Error while rendering tooltip. Please refer tooltip documentation for more details. https://path-designsystem.elluciancloud.com/#/components/Tooltip');
    console.error('Error details:', error);
    console.error('Info:', info);
  };
  _proto.render = function render() {
    return this.props.children;
  };
  return TooltipErrorBoundry;
}(React.Component);
TooltipErrorBoundry.propTypes = {
  /**
   * Tooltip reference element.
   */
  children: PropTypes.element
};
export default TooltipErrorBoundry;